import { permissionActions } from "./permission-slice";
import { uiActions } from "../ui-slice";

export const Getpermissions = (email, showNotification) => {
  return async (dispatch) => {
    if (showNotification !== undefined && showNotification === true) {
      dispatch(
        uiActions.showNotification({
          status: "pending",
          title: "Cargando información",
          message: "Se esta solicitando la información al servidor.",
        })
      );
    }
    const GetpermissionsInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/Permission/getall`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener la información solicitada");
      }
      const data = await response.json();
      return data;
    };

    try {
      const response = await GetpermissionsInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          permissionActions.setpermissions({
            permissions: response.data.map((permission) => {
              return {
                ...permission,
                status: permission.status === true ? "Activo" : "Inactivo",
              };
            }),
          })
        );
        if (showNotification !== undefined && showNotification === true) {
          dispatch(
            uiActions.showNotification({
              status: "success",
              title: "Datos Cargados",
              message: response.result.message,
            })
          );
        }
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          permissionActions.setpermissions({
            statues: [],
          })
        );
        if (showNotification !== undefined && showNotification === true) {
          dispatch(
            uiActions.showNotification({
              status: "warning",
              title: "Advertencia",
              message: response.result.message,
            })
          );
        }
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener la información solicitada",
        })
      );
    }
  };
};
export const Getpermission = (id, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Solicitando permiso",
        message: "Solicitando permiso al servidor.",
      })
    );
    const getpermissionInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/Permission/getById`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo obtener el permiso");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await getpermissionInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          permissionActions.setpermission({
            permission: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "Datos Cargados",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          permissionActions.setpermission({
            permission: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo obtener el permiso",
        })
      );
    }
  };
};
export const Updatepermission = (permission, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Actualizando permiso",
        message: "Solicitando Actualización del permiso al servidor.",
      })
    );
    const updatepermissionInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/Permission/update`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Id: permission.id,
            Name: permission.name,
            Code: permission.code,
            Description: permission.description,
            Status: permission.status,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo actualizar el permiso");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await updatepermissionInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          permissionActions.setpermission({
            permission: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "permiso Actualizado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          permissionActions.setpermission({
            permission: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo actualizar el permiso",
        })
      );
    }
  };
};
export const Createpermission = (permission, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Creando permiso",
        message: "Solicitando Creación del permiso al servidor.",
      })
    );
    const createpermissionInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/Permission/create`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Name: permission.name,
            Code: permission.code,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo crear el permiso");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await createpermissionInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          permissionActions.setpermission({
            permission: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "permiso Creado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          permissionActions.setpermission({
            permission: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo crear el permiso",
        })
      );
    }
  };
};
export const Activepermission = (id, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Activando permiso",
        message: "Solicitando activación del permiso al servidor.",
      })
    );
    const activepermissionInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/Permission/active`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo activar el permiso");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await activepermissionInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          permissionActions.setpermission({
            permission: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "permiso Activado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          permissionActions.setpermission({
            permission: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo activar el permiso",
        })
      );
    }
  };
};
export const Inactivepermission = (id, email) => {
  return async (dispatch) => {
    dispatch(
      uiActions.showNotification({
        status: "pending",
        title: "Inactivando permiso",
        message: "Solicitando activación del permiso al servidor.",
      })
    );
    const inactivepermissionInfo = async () => {
      const response = await fetch(
        `${process.env.REACT_APP_URL}digitalsign/user/Permission/inactive`,
        {
          method: "POST",
          body: JSON.stringify({
            UserName: email,
            Id: id,
          }),
          headers: {
            "Content-Type": "application/json",
            APIKey: process.env.REACT_APP_KEY,
            APISecretKey: process.env.REACT_APP_SECRET_KEY,
            APPName: process.env.REACT_APP_NAME,
          },
        }
      );
      if (!response.ok) {
        throw new Error("No se pudo inactivar el permiso");
      }
      const data = await response.json();
      return data;
    };
    try {
      const response = await inactivepermissionInfo();
      if (response.result.errorCode === "OK") {
        dispatch(
          permissionActions.setpermission({
            permission: response.data,
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "success",
            title: "permiso Inactivado",
            message: response.result.message,
          })
        );
      }
      if (response.result.errorCode === "Warning") {
        dispatch(
          permissionActions.setpermission({
            permission: {},
          })
        );
        dispatch(
          uiActions.showNotification({
            status: "warning",
            title: "Advertencia",
            message: response.result.message,
          })
        );
      }
    } catch (error) {
      dispatch(
        uiActions.showNotification({
          status: "error",
          title: "Error!",
          message: "No se pudo inactivar el permiso",
        })
      );
    }
  };
};
